import {
    CompanyDashboardSelect,
    CompanyListSocial,
    Dashboard,
    infoscreenLayoutView,
    SocialGroupDashboardSelect,
    SocialGroupList,
} from '../../Types/AuthServer';

export function autofillInfoscreen(
    infoscreens: CompanyDashboardSelect[] | SocialGroupDashboardSelect[],
    id: string,
    owner?: CompanyListSocial | SocialGroupList,
) {
    return infoscreens.map((infoscreen) => {
        if (infoscreen.id === id) {
            // If the dashboard is already filled, return it as is
            if (Object.keys(infoscreen.dashboard).length > 0) {
                return infoscreen;
            }
            // If the dashboard is empty, autofill it
            const users = owner?.users || [];
            const layoutViews: infoscreenLayoutView[] = [];
            let currentView = {
                fullscreen: null,
                id: 1,
                itemsRow1: [] as string[],
                itemsRow2: [] as string[],
                type: 'people',
            };

            users.forEach((user, index) => {
                const position = index % 10;
                if (position < 5) {
                    currentView.itemsRow1.push(user.id);
                } else {
                    currentView.itemsRow2.push(user.id);
                }

                if (position === 9 || index === users.length - 1) {
                    layoutViews.push(currentView);
                    currentView = {
                        fullscreen: null,
                        id: currentView.id + 1,
                        itemsRow1: [],
                        itemsRow2: [],
                        type: 'people',
                    };
                }
            });

            const autofilledDashboard: Dashboard['socials'] = {
                backgroundColor: '#000000',
                backgroundImage: '',
                backgroundSize: 'cover',
                carouselInterval: 30,
                clockColor: '#ffffff',
                hasLocation: false,
                hasSecondLogo: false,
                hasUserTitle: false,
                image1: owner?.image,
                image1Size: 'contain',
                image2: '',
                image2Size: 'contain',
                layoutViews,
                onlineTime: {
                    end: '',
                    showWeekDay: [1, 2, 3, 4, 5, 6, 7],
                    start: '',
                },
                poweredBlack: false,
                textColor: '#ffffff',
                title: owner?.name,
                titleColor: '#ffffff',
                tz: '',
            };

            return { ...infoscreen, dashboard: { ...infoscreen.dashboard, socials: autofilledDashboard } };
        }
        return infoscreen;
    });
}
